import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pb-32 w-full bg-[#242424] text-[#fff]" }

import { ref, onMounted } from "vue";
import { getCurrentPage } from "@/router/local-router.ts";
import NavHeader from "@/components/navigation/NavigationHeader.vue";
import NavFooter from "@/components/navigation/nav-footer.vue";
import RequestQuoteForm from "@/components/common/request-quote-form.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'dark',
  setup(__props) {

const currentView = ref(getCurrentPage());

const updateView = () => {
  window.scrollTo(0, 0);
  currentView.value = getCurrentPage();
};

onMounted(() => {
  window.addEventListener("pathchange", updateView);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(NavHeader, { class: "z-50 sticky top-0" }),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(currentView.value))),
      _createVNode(RequestQuoteForm, {
        class: "mb-60",
        mode: "dark"
      })
    ]),
    _createVNode(NavFooter)
  ], 64))
}
}

})